/*
 * @description: 中文说明
 * @author: zb
 * @update: zb
 * @LastEditors: zb
 * @Date: 2019-04-29 09:58:18
 * @LastEditTime: 2019-05-16 13:40:20
 */

import { formatTime } from './formatTimeFilter.js'
import { formatPhone } from './phoneSafeFilter.js'

function Filters() {}

Filters.install = function(Vue) {
  Vue.filter('_data', formatTime)
  Vue.filter('safePhone', formatPhone)
}

export default [formatTime, formatPhone]
export { Filters }
